// extracted by mini-css-extract-plugin
export default {"archive_banner":"ArchivedAccountPage_archive_banner__cLWYJ"};